<div class="full-page bg-black w-100">
  <div class="">
    <img class="logo mx-auto mb-4 w-100 text-center" src="/assets/images/nav-logo.svg" />
    <div class="reg-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
